import React, { useEffect } from 'react';
import {
  Dialog as MaterialDialog,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import { HighlightOff } from '@material-ui/icons';
import { SimulationDetailPopUpProps } from './interfaces';
import { useStyles } from './styles';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { loadStrategyAction } from 'modules/strategy';
import { isLoading } from 'utils/loading';
import Loading from 'components/Loading';
import { FORM_MODE } from 'shared/enums';
import RemoveForm from './RemoveForm';

const RemoveContractPopUp: React.FC<SimulationDetailPopUpProps> = ({
  show,
  strategy,
  handleClose,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    strategy &&
      dispatch(
        loadStrategyAction({ id: strategy.id, mode: FORM_MODE.listDetail }),
      );
  }, []);

  const { loading: loadingStrategy, current: loadedStrategy } = useSelector(
    (state: RootState) => state.strategy,
  );

  const loading = isLoading([loadingStrategy]);

  const onCloseDialog = () => {
    handleClose();
  };

  const classes = useStyles({});

  return loading ? (
    <Loading />
  ) : (
    <MaterialDialog
      open={show}
      onClose={onCloseDialog}
      maxWidth={false}
      PaperProps={{ className: classes.dialogPaper }}
      className={classes.dialogContainer}
    >
      <Grid
        container
        justifyContent="flex-end"
        className={classes.closeContainer}
      >
        <HighlightOff
          className={classes.closeIcon}
          color="action"
          fontSize="medium"
          onClick={onCloseDialog}
        />
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="stretch"
        className={classes.container}
      >
        <Grid container direction="column" alignItems="center">
          <DialogTitle>Remover Distribuição</DialogTitle>
          <DialogTitle>{loadedStrategy?.name || ''}</DialogTitle>
        </Grid>
        <Grid container direction="column">
          <DialogContent className={classes.dialogContent}>
            <RemoveForm handleClose={onCloseDialog} />
          </DialogContent>
        </Grid>
      </Grid>
    </MaterialDialog>
  );
};
export default RemoveContractPopUp;
